var INPUT_STYLE = {
  backgroundColor: "var(--sds-bg-base-default)",
  borderColor: "var(--sds-border-base-secondary)",
  color: "var(--sds-text-base-default)",
  "&::placeholder": {
    color: "var(--sds-text-base-secondary)"
  },
  "&:disabled": {
    backgroundColor: "var(--sds-bg-disabled-default)",
    borderColor: "var(--sds-border-disabled-default)",
    color: "var(--sds-text-disabled-placeholder)"
  }
};
var DROPDOWN_STYLE = {
  backgroundColor: "var(--sds-bg-base-default)",
  borderColor: "var(--sds-border-base-secondary)"
};
var ITEM_STYLE = {
  color: "var(--sds-text-base-default)",
  "&[data-hovered]": {
    backgroundColor: "var(--sds-bg-base-secondary)"
  },
  "&[data-selected]": {
    "&, &:hover": {
      backgroundColor: "var(--sds-bg-brand-tertiary)",
      color: "var(--sds-text-brand-default)"
    },
    "&[data-hovered]": {
      backgroundColor: "var(--sds-bg-brand-tertiary-hover)"
    }
  }
};

/** Mantine input styles mapping filter controls onto SDS surface tokens (dark-mode aware). */
export var FILTER_INPUT_STYLES = {
  input: INPUT_STYLE
};

/** Mantine styles for select-type filters, theming both the input and the open dropdown panel. */
export var FILTER_SELECT_STYLES = {
  input: INPUT_STYLE,
  dropdown: DROPDOWN_STYLE,
  item: ITEM_STYLE
};